
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150 150"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M121.37 147.38H89.21a1.49 1.49 0 01-1.49-1.49v-21.11a12.17 12.17 0 00-12.16-12.15h-1.11a12.17 12.17 0 00-12.16 12.15v21.11a1.49 1.49 0 01-1.49 1.49H28.64a1.49 1.49 0 01-1.49-1.49V78.08H2.51a1.48 1.48 0 01-1-2.53L74 3.06a1.48 1.48 0 012.1 0l72.49 72.49a1.48 1.48 0 01-1 2.53h-24.73v67.81a1.49 1.49 0 01-1.49 1.49z","fill":"#fff"}})])
          )
        }
      }
    